<template>
	<div class="pui-form">
		<mtipomanipulacion-modals :modelName="modelName"></mtipomanipulacion-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mtipomanipulacion-form-header
				:modelPk="modelPk"
			></mtipomanipulacion-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPOMAN -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idtipoman-mtipomanipulacion`"
									v-model="model.idtipoman"
									:label="$t('mtipomanipulacion.idtipoman')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODMANEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codmanedi-mtipomanipulacion`"
									v-model="model.codmanedi"
									:label="$t('mtipomanipulacion.codmanedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mtipomanipulacion`"
									v-model="model.name"
									:label="$t('mtipomanipulacion.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="30"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mtipomanipulacion`"
									v-model="model.fecbaja"
									:label="$t('mtipomanipulacion.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mtipomanipulacionActions from './MtipomanipulacionActions';
import mtipomanipulacionModals from './MtipomanipulacionModals.vue';

export default {
	name: 'mtipomanipulacion-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mtipomanipulacion-modals': mtipomanipulacionModals
	},
	data() {
		return {
			modelName: 'mtipomanipulacion',
			actions: mtipomanipulacionActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mtipomanipulacion');
		}
	},
	created() {}
};
</script>
